/* eslint-disable react/jsx-no-bind */

import { BrowserRouter as Router } from 'react-router-dom';
import React from 'react';
import RootContainer from './RootContainer';

const licenseQueryParam = 'everviz_licenseid';

export default function App() {
  return (
    <Router>
      <div className={'page-container container-fluid '}>
        <RootContainer />
      </div>
    </Router>
  );
}
